'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { useState, useEffect } from 'react';
import clsx from 'clsx';
import { Collection } from './CollectionsContext';
import CollectionDetailLink from './CollectionlDetailLink';
import { CollectionSettings } from './CollectionSettings';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { useIsMobile } from '@/hooks/use-mobile';
interface CollectionCardProps {
  collection: Collection;
  isOwner?: boolean;
  showMenu?: boolean;
  linkCard?: boolean;
}
export function CollectionCard(t0) {
  const $ = _c(65);
  const {
    collection: initialCollection,
    isOwner: t1,
    showMenu: t2,
    linkCard: t3
  } = t0;
  const isOwner = t1 === undefined ? false : t1;
  const showMenu = t2 === undefined ? false : t2;
  const linkCard = t3 === undefined ? false : t3;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const [collection, setCollection] = useState(initialCollection);
  useIsMobile();
  let t4;
  let t5;
  if ($[0] !== initialCollection) {
    t4 = () => {
      setCollection(initialCollection);
    };
    t5 = [initialCollection];
    $[0] = initialCollection;
    $[1] = t4;
    $[2] = t5;
  } else {
    t4 = $[1];
    t5 = $[2];
  }
  useEffect(t4, t5);
  let t6;
  if ($[3] !== isMenuOpen) {
    t6 = e => {
      e.preventDefault();
      e.stopPropagation();
      setIsMenuOpen(!isMenuOpen);
    };
    $[3] = isMenuOpen;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const handleMenuClick = t6;
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = updatedCollection => {
      setCollection(updatedCollection);
    };
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const handleCollectionUpdate = t7;
  let t8;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = e_0 => {
      e_0.preventDefault();
      e_0.stopPropagation();
      setIsSettingsOpen(true);
      setIsMenuOpen(false);
    };
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  const handleSettingsClick = t8;
  const CardWrapper = linkCard ? Link : "div";
  let t9;
  if ($[7] !== collection.id || $[8] !== linkCard) {
    t9 = linkCard ? {
      href: `/collections/${collection.id}`,
      className: "group bg-white rounded-2xl hover:shadow-lg transition-all overflow-hidden border border-gray-100 block text-left"
    } : {
      className: "group bg-white rounded-2xl hover:shadow-lg transition-all overflow-hidden border border-gray-100"
    };
    $[7] = collection.id;
    $[8] = linkCard;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const cardProps = t9;
  let t10;
  if ($[10] !== collection.id || $[11] !== linkCard) {
    t10 = t11 => {
      const {
        children,
        className
      } = t11;
      if (linkCard) {
        return <div className={className}>{children}</div>;
      }
      return <CollectionDetailLink id={collection.id} className={className}>{children}</CollectionDetailLink>;
    };
    $[10] = collection.id;
    $[11] = linkCard;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  const InnerWrapper = t10;
  const t11 = cardProps as any;
  let t12;
  if ($[13] !== collection.image || $[14] !== collection.name) {
    t12 = collection.image ? <img src={collection.image} alt={collection.name} className="absolute inset-0 w-full h-full object-cover" /> : <div className="absolute inset-0 flex items-center justify-center"><div className="grid grid-cols-2 gap-1 opacity-30">{[1, 2, 3, 4].map(_temp)}</div></div>;
    $[13] = collection.image;
    $[14] = collection.name;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== handleMenuClick || $[17] !== isMenuOpen || $[18] !== isOwner || $[19] !== showMenu) {
    t13 = isOwner && <div className="absolute top-3 right-3 flex items-center gap-2">{showMenu && <div className="relative"><button onClick={handleMenuClick} className="w-8 h-8 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white transition-colors"><svg className="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" /></svg></button>{isMenuOpen && <div className="absolute right-0 top-10 w-48 bg-white rounded-xl shadow-lg border border-gray-100 py-1 z-10"><button onClick={handleSettingsClick} className="w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50 flex items-center gap-2"><svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>Settings</button></div>}</div>}</div>;
    $[16] = handleMenuClick;
    $[17] = isMenuOpen;
    $[18] = isOwner;
    $[19] = showMenu;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  const t14 = collection.visibility === "private" ? "bg-gray-100 text-gray-600" : "bg-green-100 text-green-700";
  let t15;
  if ($[21] !== t14) {
    t15 = clsx("px-2.5 py-1 rounded-full text-xs font-medium flex items-center gap-1", t14);
    $[21] = t14;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== collection.visibility) {
    t16 = collection.visibility === "private" ? <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg> : <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
    $[23] = collection.visibility;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== collection.visibility || $[26] !== t15 || $[27] !== t16) {
    t17 = <div className="absolute top-3 left-3"><span className={t15}>{t16}{collection.visibility}</span></div>;
    $[25] = collection.visibility;
    $[26] = t15;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t12 || $[30] !== t13 || $[31] !== t17) {
    t18 = <div className="h-32 bg-gradient-to-br from-primary-100 via-primary-50 to-white relative">{t12}{t13}{t17}</div>;
    $[29] = t12;
    $[30] = t13;
    $[31] = t17;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== collection.name) {
    t19 = <h3 className="font-bold text-lg text-gray-900 mb-2 truncate group-hover:text-primary-600 transition-colors">{collection.name}</h3>;
    $[33] = collection.name;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== collection.description) {
    t20 = collection.description && <p className="text-sm text-gray-500 line-clamp-3 mb-3">{collection.description}</p>;
    $[35] = collection.description;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t19 || $[38] !== t20) {
    t21 = <div>{t19}{t20}</div>;
    $[37] = t19;
    $[38] = t20;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== InnerWrapper || $[41] !== t21) {
    t22 = <div className="flex-1"><InnerWrapper>{t21}</InnerWrapper></div>;
    $[40] = InnerWrapper;
    $[41] = t21;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  let t24;
  if ($[44] !== InnerWrapper) {
    t24 = <div className="pt-4 border-t border-gray-50 flex items-center justify-end"><InnerWrapper className="text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 text-sm transition-colors">View{t23}</InnerWrapper></div>;
    $[44] = InnerWrapper;
    $[45] = t24;
  } else {
    t24 = $[45];
  }
  let t25;
  if ($[46] !== t22 || $[47] !== t24) {
    t25 = <div className="p-5 flex flex-col h-[calc(100%-8rem)]">{t22}{t24}</div>;
    $[46] = t22;
    $[47] = t24;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== CardWrapper || $[50] !== t11 || $[51] !== t18 || $[52] !== t25) {
    t26 = <CardWrapper {...t11}>{t18}{t25}</CardWrapper>;
    $[49] = CardWrapper;
    $[50] = t11;
    $[51] = t18;
    $[52] = t25;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  let t27;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <DialogHeader><DialogTitle>Collection Settings</DialogTitle></DialogHeader>;
    $[54] = t27;
  } else {
    t27 = $[54];
  }
  let t28;
  let t29;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = updatedCollection_0 => {
      handleCollectionUpdate(updatedCollection_0);
      setIsSettingsOpen(false);
    };
    t29 = () => setIsSettingsOpen(false);
    $[55] = t28;
    $[56] = t29;
  } else {
    t28 = $[55];
    t29 = $[56];
  }
  let t30;
  if ($[57] !== collection) {
    t30 = <DialogContent className="sm:max-w-md">{t27}<CollectionSettings collection={collection} onSave={t28} onCancel={t29} /></DialogContent>;
    $[57] = collection;
    $[58] = t30;
  } else {
    t30 = $[58];
  }
  let t31;
  if ($[59] !== isSettingsOpen || $[60] !== t30) {
    t31 = <Dialog open={isSettingsOpen} onOpenChange={setIsSettingsOpen}>{t30}</Dialog>;
    $[59] = isSettingsOpen;
    $[60] = t30;
    $[61] = t31;
  } else {
    t31 = $[61];
  }
  let t32;
  if ($[62] !== t26 || $[63] !== t31) {
    t32 = <>{t26}{t31}</>;
    $[62] = t26;
    $[63] = t31;
    $[64] = t32;
  } else {
    t32 = $[64];
  }
  return t32;
}
function _temp(i) {
  return <div key={i} className="w-12 h-12 bg-primary-300 rounded-lg" />;
}